import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { WithdrawParams } from './useWithdrawMutation';

type WithdrawValidationDTO =
  | {
      canProcessTransfer: true;
      rejectReason: null;
      messageLevel: null;
      note: string;
    }
  | {
      canProcessTransfer: false;
      rejectReason: string;
      messageLevel: 'Error' | 'Warning';
    };

const validateWithdraw = async (params: WithdrawParams): Promise<WithdrawValidationDTO> =>
  authFetch('/Consumer/AchTransfers/ValidateWithdrawal', {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });

export const useValidateWithdrawMutation = () => {
  return useMutation(validateWithdraw);
};
